import { render, staticRenderFns } from "./businees_publish.vue?vue&type=template&id=f3f536a4"
import script from "./businees_publish.vue?vue&type=script&lang=js"
export * from "./businees_publish.vue?vue&type=script&lang=js"
import style0 from "./businees_publish.vue?vue&type=style&index=0&id=f3f536a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports